import { render } from "./wechatMenu.vue?vue&type=template&id=4b8e5e21&scoped=true&ts=true"
import script from "./wechatMenu.vue?vue&type=script&lang=ts"
export * from "./wechatMenu.vue?vue&type=script&lang=ts"

import "./wechatMenu.vue?vue&type=style&index=0&id=4b8e5e21&scoped=true&lang=css"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8e5e21"]])

export default __exports__